module.exports = __webpack_public_path__ + "img/twitter-icon.b40b48e1.svg";